import React from "react";
import { Box, Button, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Confirm } from "../modal/confirm";

type Props = {
  disabled?: boolean;
  onClick?:
    | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void)
    | undefined;
  pending?: boolean;
};

const Wrapper: React.FC = (props) => (
  <Box display="flex" justifyContent="flex-end">
    {React.Children.map(props.children, (child, index) => (
      <Box ml={index ? 2 : 0}>{child}</Box>
    ))}
  </Box>
);

const Action: React.FC<
  Props & {
    outlined?: boolean;
  }
> = (props) => (
  <Button
    variant={props.outlined ? "outlined" : "contained"}
    disabled={props.disabled}
    onClick={props.onClick}
    startIcon={
      props.pending ? <CircularProgress size={16} color="inherit" /> : null
    }
  >
    {props.children}
  </Button>
);

const Cancel: React.FC<Props> = (props) => {
  const history = useHistory();
  const [open, setOpen] = React.useState<boolean>(false);
  const onClick = React.useCallback(() => {
    setOpen(!open);
  }, [open]);
  return (
    <React.Fragment>
      <Button variant="outlined" disabled={props.disabled} onClick={onClick}>
        Cancel
      </Button>
      <Confirm
        open={open}
        close={onClick}
        onConfirm={() => history.push("/")}
      />
    </React.Fragment>
  );
};

const Previous: React.FC<Props> = (props) => (
  <Action outlined disabled={props.disabled} onClick={props.onClick}>
    Previous
  </Action>
);

const SaveAsDraft: React.FC<Props> = (props) => (
  <Action outlined disabled={props.disabled} onClick={props.onClick}>
    Save as Draft
  </Action>
);

const Next: React.FC<Props> = (props) => (
  <Action disabled={props.disabled} onClick={props.onClick}>
    Next
  </Action>
);

const Submit: React.FC<Props> = (props) => (
  <Action
    disabled={props.pending || props.disabled}
    onClick={props.onClick}
    pending={props.pending}
  >
    {props.pending ? "Submitting Request..." : "Submit Request"}
  </Action>
);

export const Actions = Object.assign(Wrapper, {
  Action,
  Cancel,
  Previous,
  SaveAsDraft,
  Next,
  Submit,
});
